// extracted by mini-css-extract-plugin
export var distanceToArrivalStationCell = "_3d8e952e9ada11761aeff5cf41578928-css";